import React from "react";
import styles from "./DonationModal.module.scss";

import CheckoutForm from "./CheckoutForm";

import NavButton from "../SiteNav/NavButton/NavButton";
import { useLocale } from "../../i18n/LocaleContext";

const DonationModal = (props) => {
  const { t } = useLocale();
  const classes = [styles.DonationModal];

  if (props.show) {
    classes.push(styles.Show);
  }

  return (
    <React.Fragment>
      <div className={classes.join(" ")}>
        <div className={styles.CheckoutPanelContainer}>
          <CheckoutForm showing={props.show} successAmount={props.successAmount} />
          <p className={styles.RespectPrivacy}>{t("donation.privacy")}</p>
        </div>
        <div className={styles.NavButtonContainer}>
          <NavButton
            type="menu"
            collapse={true}
            buttonClickListener={(e) => props.closeDonationModal()}
            sideDrawerOpen={true}
          ></NavButton>
        </div>
      </div>
      <div className={styles.Backdrop} />
    </React.Fragment>
  );
};

export default DonationModal;
